import { Matrix } from 'app/models/questions/Matrix'
import { AbstractControl, UntypedFormGroup } from '@angular/forms'
import { FormFillingError } from 'app/custom-errors/FormFillingError'
import { QuestionComponent } from 'app/models/questions/QuestionComponent'
import {
  CheckboxMatrixComponent
} from 'app/modules/survey/survey-viewer/survey-question/types/checkbox-matrix/checkbox-matrix.component'
import { ICheckbox } from 'app/interfaces/ICheckbox'
import {
  CheckboxMatrixPropertyValidator
} from 'app/models/questions/property-validator/CheckboxMatrixPropertyValidator'

export class CheckboxMatrix extends Matrix implements ICheckbox {

  private readonly _uniqueMentionKey: string

  constructor(question) {
    super(question)

    this._uniqueMentionKey = question.uniqueMentionKey

    new CheckboxMatrixPropertyValidator(question).validate()
  }

  getDisplayComponent() {
    return new QuestionComponent(CheckboxMatrixComponent, this)
  }

  fillFormWithDummyAnswer(surveyForm: UntypedFormGroup, iterator = 0, maxRetries = 200) {
    if (surveyForm.controls[this.key].valid && surveyForm.controls[this.key].dirty) {
      return
    }

    if (iterator >= maxRetries) {
      throw new FormFillingError().cannotMakeQuestionValid(this.key, iterator)
    }

    this.resetForm(surveyForm)

    this.statementKeys.forEach(() => {
      this.fillRandomControl(surveyForm)
    })

    surveyForm.controls[this.key].markAsDirty()

    iterator++
    this.fillFormWithDummyAnswer(surveyForm, iterator, maxRetries)
  }

  resetOtherStatementsOnUniqueMentionStatementSelection(rKey: string, statementKey: string, formGroup: AbstractControl) {
    if (!this.useUniqueMentionLabel) {
      return
    }

    if (statementKey === this.uniqueMentionKey) {
      this.statementsOrder.forEach(sKey => {
        if (sKey !== statementKey) {
          formGroup.get(rKey).get(this.formControlName).get(sKey).setValue(false)
        }
      })
      return
    }

    formGroup.get(rKey).get(this.formControlName).get(this.uniqueMentionKey).setValue(false)
  }

  get uniqueMentionKey() {
    return this._uniqueMentionKey
  }
}
